import request from '@/utils/request'
/**
 * @apiName 租赁方案绑定记录分页列表
 * @param  data {itemType:项目类型 0套餐/1单品,maintenanceType:维保类型 0保养/1维修,
 * storeId:适用维修厂ID,collaborationId:本地合作关系ID,serviceId:本地服务商ID,
 * rentPlanId:租赁方案ID,rentPlanType:租赁方案类型 1个人/2企业}
 * @returns
 */
export function maintenancePlanBindListApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/itemRentPlanLink/pageList',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 租赁方案名称模糊查询
 * @param  data {name:名称,rentPlanType:租赁方案类型  1 "个人租赁方案"  2 "企业租赁方案",allFlag}
 * @returns
 */
export function getRentPlanNamesApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/likeByName',
    method: 'POST',
    data,
  })
}
